module.exports = __webpack_public_path__ + "img/mon-1.22f5e856.png";